import { jsonObject, jsonMember } from 'typedjson';

@jsonObject
export class SequenceSearchResultHitSegmentPairResponse {
  @jsonMember readonly alignLength!: number;
  @jsonMember readonly bitScore!: number;
  @jsonMember readonly expectedValue!: number;
  @jsonMember readonly gaps!: number;
  @jsonMember readonly hitFrom!: number;
  @jsonMember readonly hitSequence!: string;
  @jsonMember readonly hitStrand!: string;
  @jsonMember readonly hitTo!: number;
  @jsonMember readonly identity!: number;
  @jsonMember readonly midline!: string;
  @jsonMember readonly num!: number;
  @jsonMember readonly queryFrom!: number;
  @jsonMember readonly querySequence!: string;
  @jsonMember readonly queryStrand!: string;
  @jsonMember readonly queryTo!: number;
  @jsonMember readonly score!: number;
}
